import { useDispatch, useSelector } from "react-redux";
import LogoFilter from "Assets/monitoring/filter.png";
import {
  realtimeCamera,
  realtimeSelected,
  realtimeSelectedCamera,
  realtimeSidebar,
} from "slice/realtimeSlice";
import { LinearProgress, Typography } from "@mui/material";
// import { useOrganization } from "contexts/OrganizationContext";
import { getIpCamList } from "slice/ipCamSlice";
import { useEffect, useMemo, useState } from "react";
import FilterListIcon from "@mui/icons-material/FilterList";
import FilterListOffIcon from "@mui/icons-material/FilterListOff";
import { SearchIcon } from "@heroicons/react/outline";
import { getJurisdictionList } from "slice/jurisdictionSlice";
import { getUserInfo } from "Config/getUserInfo";
import ComponentN from "./RealTime/DataSidebar/ComponentN";
import ComponentNonN from "./RealTime/DataSidebar/ComponentNonN";
import { useDebounce } from "use-debounce";
import { clearTargetIsDpo } from "slice/targetIsDpoSlice";
import { clearTarget } from "slice/targetSlice";
import { subs, subscribeMessage, unsubscribeMessage } from "Config/natsClient";

const user = getUserInfo() || {};
const userInfo = user?.userInfo;
const jurisdiction_level_code = userInfo?.jurisdiction_level_code;
// console.log(jurisdiction_level_code, "jurisdiction_level_code");

const Sidebar = () => {
  const dispatch = useDispatch();
  const realtime = useSelector((state) => state.realtime.value);
  const {
    dataJurisdictionList,
    isLoadingJurisdictionList,
    errorJurisdictionList,
  } = useSelector((state) => state.jurisdiction.jurisdictionList);
  const { dataIpCamList, isLoadingIpCamList, errorIpCamList } = useSelector(
    (state) => state.ipCam.ipCamList
  );

  const [datajurisdiction, setDatajurisdiction] =
    useState(dataJurisdictionList);
  const [dataRealtime, setDataRealtime] = useState(dataIpCamList);
  const [isSorted, setIsSorted] = useState(false);
  const [search, setSearch] = useState("");
  const [debouncedSearch] = useDebounce(search, 2000);
  const [currentVideoId, setCurrentVideoId] = useState(null);
  // console.log(isSorted);

  const toggleSort = () => {
    if (dataIpCamList?.length === 0 || realtime === "") {
      if (isSorted) {
        setDataRealtime(dataIpCamList);
      } else {
        const sortedData = [...dataRealtime].sort((a, b) =>
          a.device_name.localeCompare(b.device_name)
        );
        setDataRealtime(sortedData);
      }
    }
    setIsSorted(!isSorted);
  };
  // console.log(dataRealtime, "dataRealtime");

  const handleClick = (item) => {
    dispatch(realtimeSidebar(item));
  };

  // console.log(currentVideoId, 'currentVideoId')
  const handleClickCamera = (item) => {
    const subs = localStorage.getItem("subs");
    dispatch(clearTargetIsDpo([]));
    dispatch(clearTarget([]));
    const prevVideoId = currentVideoId;
    if (subs !== prevVideoId || subs !== item?.id) {
      unsubscribeMessage(subs);
    }
    if (prevVideoId !== item?.id && prevVideoId !== null) {
      // console.log(`%cUnsubscribe video ${prevVideoId}`, "color: red;");
      unsubscribeMessage(prevVideoId);
    }
    setCurrentVideoId(item?.id); // setelah itu baru update
    dispatch(realtimeCamera(item));
    dispatch(realtimeSelected(item));
    dispatch(realtimeSelectedCamera(item));
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        await dispatch(getJurisdictionList({ page: 0, size: 99 }));
      } catch (error) {
        console.error("Error fetching data:", error.message);
      }
    };

    fetchData();
  }, [dispatch]);

  useEffect(() => {
    setDataRealtime(dataIpCamList);
  }, [dataIpCamList, debouncedSearch]);

  useEffect(() => {
    dispatch(
      getIpCamList({
        page: 0,
        size: 99,
        keywords: debouncedSearch,
      })
    );
  }, [debouncedSearch, dispatch]);
  // console.log(dataRealtime, "dataRealtime");
  // console.log(dataIpCamList, "dataIpCamList");

  return (
    <div className="h-full">
      <div className="px-6 py-5">
        <div className="relative rounded-md shadow-sm">
          <input
            type="text"
            name="search"
            id="search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="placeholder:italic block w-full pr-10 min-w-52 sm:text-sm border-gray-300 rounded-lg px-2 py-2 border text-black"
            placeholder="Search Camera"
          />
          <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
            <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
          </div>
        </div>
      </div>

      <div className="w-full h-full text-white p-6 pt-2 flex flex-col relative">
        <div className="w-full flex justify-between gap-16 mb-4">
          <h3 className="text-sm font-semibold hidden md:block">
            List of Camera
          </h3>
          <div className="w-8 h-8 cursor-pointer" onClick={toggleSort}>
            {isSorted ? <FilterListIcon /> : <FilterListOffIcon />}
          </div>
        </div>

        <div className="w-full overflow-y-auto max-h-96">
          {isLoadingIpCamList ? (
            <LinearProgress />
          ) : (
            <div className="">
              <div>
                <ComponentNonN
                  dataIpCamList={dataRealtime}
                  handleClickCamera={handleClickCamera}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
